$(document).ready(function () {
  var container = $("#advisoryBlock");
  if (!container.length) return;

  function open(flag) {
    var tablinks = container.find(".tablink");
    var tabcontents = container.find(".tabcontent");
    var openedIdx = 0;

    for (var i = 0; i < tablinks.length; i++) {
      if ($(tablinks[i]).hasClass("open")) {
        openedIdx = i;
        break;
      }
    }

    $(tablinks[openedIdx]).removeClass("open");
    $(tabcontents[openedIdx]).removeClass("open");

    var nextIdx = 0;
    if (flag) {
      if (openedIdx == tablinks.length - 1) {
        nextIdx = 0;
      } else {
        nextIdx = openedIdx + 1;
      }
    } else {
      if (openedIdx == 0) {
        nextIdx = tablinks.length - 1;
      } else {
        nextIdx = openedIdx - 1;
      }
    }

    console.log(nextIdx);
    $(tablinks[nextIdx]).addClass("open");
    $(tabcontents[nextIdx]).addClass("open");

    var width = container.find(".swiper-wrapper.board-tabs .swiper-slide.carousel-cell")[0]
      .style.width;
    var offset = nextIdx * parseInt(width);
    console.log("offset =", offset);

    container.find(".swiper-wrapper.board-tabs").css(
      "transform",
      "translate3d(-" + offset + "px, 0px, 0px)"
    );
  }

  container.find(".slider-reviews-prev").click(function () {
    open(false);
  });
  container.find(".slider-reviews-next").click(function () {
    open(true);
  });
});